// `/admin/queue` — kept resolving. The routing sheet now lives on `/available`.
//
// Execution is a strategist's surface. This URL is still the admin's muscle memory
// and is linked from the console, so it redirects to the merged page, anchored at
// the proposals, rather than 404ing. A strategist and a viewer are not admitted.

import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { AccessDeniedError, fetchMe } from '../api/client';
import { useAuthContext } from '../auth/AuthContext';
import { DeniedGate } from '../auth/Gate';

export function QueueView() {
  const { getToken, email, signOut } = useAuthContext();

  const meQuery = useQuery({ queryKey: ['me'], queryFn: () => fetchMe(getToken) });
  const viewer = meQuery.data?.viewer;

  if (meQuery.error instanceof AccessDeniedError) {
    return <DeniedGate message={meQuery.error.message} email={email} onSignOut={signOut} />;
  }
  if (meQuery.isPending) {
    return <div className="loading">Signing you in…</div>;
  }

  if (viewer && !viewer.sees_queue) {
    return <Navigate to={viewer.default_view === 'execution' ? '/execution' : '/activity'} replace />;
  }

  return <Navigate to="/available#proposals" replace />;
}
